import {
  CredentialsChangedMessage,
  CredentialsResponseMessage,
  MapDocCreatedMessage,
  NameResponseMessage,
  CredentialResponseSimpleMessage,
  SetInitialStateMessage,
  ShellMessage,
  TalkingEndMessage,
  TalkingStartMessage,
  TtsBoundaryMessage,
  TtsEnableMessage,
  UserLogoutMessage,
  MapFragmentCopiedMessage,
  TlTtsMessage
} from "../../../../commondata/messages/messages-dto";
import { inject, Injectable } from "@angular/core";
import { AuthenticationService } from "../core/authentication/authentication.service";
import { MESSAGE, MODULE_TYPE } from "../../../../commondata/messages/msg-constants";
import { InitialStateDto, UserConfigOptionsDto } from "../../../../commondata/messages/initial-state-dto";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ShellStateService } from "../shell-state.service";
import { ShareDocService } from "../share-doc/share-doc.service";
import { LoaderService } from "../shared/loader/loader.service";
import { ThemeManagerService } from "../theme-manager.service";
import { ModuleSpacesService } from "../workspace/module-spaces.service";
import { DocDto } from "../dto/doc-dto";
import { WorkspaceService } from "../workspace/workspace.service";
import { SelectionDataDto } from "../../../../commondata/messages/selection-data-dto";
import { CookieService } from "ngx-cookie-service";
import { TtsService } from "./tts.service";
import { CALLER } from "../../../../commondata/messages/caller";
import { ShellEmittersService } from "../shell-emitters.service";
import { UiConstants } from "../shared/ui-constants";
import { NetworkStatusLineService } from "./network-status-line.service";
import { DocPickerService } from "../shared/dialog/doc-picker.service";
import { MatomoTracker } from "ngx-matomo-client";
import { SnackBarService } from "./snackbar.service";
import { BuyCreditsService } from "../credits/credits.service";
import { EXTRA_TYPE } from "../workspace/constants/EXTRA_TYPE";
import { ClaireConfigService } from "../claire/claire-config.service";


@Injectable({
  providedIn: "root",
})
export class ShellMessageService {
  private isInitialized = false;
  public userInitialized = false;
  public credentialmissing = false;

  public docOpenedTime: Array<Map<string, number>> = [];
  private router = inject(Router);
  private themeManagerService = inject(ThemeManagerService);
  private loaderService = inject(LoaderService);
  private authenticationService = inject(AuthenticationService);
  private snackbarService = inject(SnackBarService);

  private CustomTokenSubscription: Subscription | undefined;
  private onChangedUserSubscription: Subscription | undefined;
  private onSendBroadcastMessageSubscription: Subscription | undefined;
  private onSendMessageToFocusedModuleSubscription: Subscription | undefined;
  private onTalkingStartSubscription: Subscription | undefined;
  private onTalkingEndSubscription: Subscription | undefined;
  private onTTSBoundarySubscription: Subscription | undefined;

  constructor(
    private cookieService: CookieService,
    private shellStateService: ShellStateService,
    private shellEmittersService: ShellEmittersService,
    private moduleSpacesService: ModuleSpacesService,
    private shareDocService: ShareDocService,
    private workspaceService: WorkspaceService,
    private ttsService: TtsService,
    private networkStatusLineService: NetworkStatusLineService,
    private docPickerService: DocPickerService,
    private tracker: MatomoTracker,
    private buyCreditsService: BuyCreditsService,
    private claireConfigService: ClaireConfigService
  ) { }

  public initialize() {
    if (this.isInitialized) return;
    this.isInitialized = true;
    this.onChangedUserSubscription?.unsubscribe();
    this.onChangedUserSubscription = this.shellEmittersService.onChangedUser.subscribe((user: any) => {
      this.sendBroadcastMessage(new CredentialsChangedMessage(this.authenticationService.reloadCredentials()));
    });
    this.onSendBroadcastMessageSubscription?.unsubscribe();
    this.onSendBroadcastMessageSubscription = this.shellEmittersService.onSendBroadcastMessage.subscribe((message: any) => {
      this.sendBroadcastMessage(message);
    });
    this.onSendMessageToFocusedModuleSubscription?.unsubscribe();
    this.onSendMessageToFocusedModuleSubscription = this.shellEmittersService.onSendMessageToFocusedModule.subscribe((message: any) => {
      this.sendMessageToFocusedModule(message);
    });
    this.onTalkingStartSubscription?.unsubscribe();
    this.onTalkingStartSubscription = this.ttsService.TalkingStart.subscribe((message: any) => {
      this.sendBroadcastMessage(new TalkingStartMessage());
    });
    this.onTalkingEndSubscription?.unsubscribe();
    this.onTalkingEndSubscription = this.ttsService.TalkingEnd.subscribe((byUser: boolean) => {
      console.log("TALKING END");
      if (byUser) {
        this.shellStateService.readingGuid = '';
      }
      if (this.shellStateService.readingGuid !== '') {
        this.sendMessageToGuid(new TalkingEndMessage(byUser), this.shellStateService.readingGuid ?? '');
      } else {
        this.sendBroadcastMessage(new TalkingEndMessage(true));
      }
      // Notify Claire
      const claireIframe = document.getElementById("claire") as HTMLIFrameElement;
      if (claireIframe) {
        const msg = new TlTtsMessage(this.shellStateService.readingGuid ?? '', false);
        claireIframe.contentWindow?.postMessage(msg, "*");
      }
    });
    this.onTTSBoundarySubscription?.unsubscribe();
    this.onTTSBoundarySubscription = this.ttsService.onBoundary.subscribe((event: SpeechSynthesisEvent) => {
      const e = { name: event.name, charIndex: event.charIndex, charLength: event.charLength, elapsedTime: event.elapsedTime };

      console.log(event);
      this.sendMessageToGuid(new TtsBoundaryMessage(e), this.shellStateService.readingGuid ?? '');

    });
  }

  handleMessage(event: MessageEvent) {
    if (!this.isInitialized) return;
    const eventData = event.data as unknown as ShellMessage;
    switch (eventData.msgType) {
      case MESSAGE.MSGTYPE.CREDENTIAL_REQUEST:
        this.userInitialized = this.sendCredentials(eventData.fromGuid);
        this.credentialmissing = false;
        this.shellEmittersService.onModuleStarting.emit();
        break;
      case MESSAGE.MSGTYPE.CREDENTIAL_MISSING:
        console.log("MISSING CREDENTIAL");
        this.credentialmissing = true;
        if (eventData.msgData.createCustomToken) {
          if (this.CustomTokenSubscription) {
            this.CustomTokenSubscription.unsubscribe();
          }
          this.CustomTokenSubscription = this.authenticationService
            .createCustomToken(this.authenticationService.getUserEmail())
            .subscribe({
              next: (token) => {
                const cred = this.authenticationService.credentials;
                if (cred !== null && cred !== undefined) {
                  cred.customToken = token.customToken;
                  this.authenticationService.setCredentials(cred);
                  this.sendCredentials(eventData.fromGuid);
                }
              },
              error: (error) => {
                console.log(error);
              },
            });
        } else {
          const currentPage = this.router.url;
          this.authenticationService.logout().subscribe(() => {
            this.router.navigate(["/login", currentPage]);
          });
        }
        break;
      case MESSAGE.MSGTYPE.USER_LOGGED_OUT:
        console.log("USER LOGGED OUT");
        const currentPage = this.router.url;
        this.router.navigate(["/login", currentPage]);
        break;
      case MESSAGE.MSGTYPE.GOTO_HOME:
        this.router.navigate(["/home"]);
        break;
      case MESSAGE.MSGTYPE.OPEN_LINK:
        const link = eventData.msgData.link;
        window.open(link, "_blank");
        break;
      case MESSAGE.MSGTYPE.BUSY_STATUS:
        this.shellEmittersService.onBusyStatusChange.emit({ docId: eventData.fromGuid, busyStatus: eventData.msgData.busyStatus });
        break;
      case MESSAGE.MSGTYPE.REQUEST_FOCUS:
        this.shellEmittersService.onFocusRequested.emit(eventData.msgData.focusId);
        break;
      case MESSAGE.MSGTYPE.DIRTY_STATE:
        this.shellEmittersService.dirtyStateChange.emit({ docId: eventData.fromGuid, dirtyStatus: eventData.msgData.dirtyStatus });
        break;
      case MESSAGE.MSGTYPE.SAVE_STATUS:
        this.shellEmittersService.saveStatusChange.emit({ docId: eventData.fromGuid, saveStatus: eventData.msgData.saveStatus });
        break;
      case MESSAGE.MSGTYPE.CLOSE:
        this.workspaceService.closeDoc(eventData.fromGuid, true);
        break;
      case MESSAGE.MSGTYPE.DOC_NAME_CHANGED:
        this.shellEmittersService.onChangeDocName.emit({ docId: event.data.msgData.docId, docName: event.data.msgData.docName });
        break;
      case MESSAGE.MSGTYPE.DOC_NAME_REQUEST:
        const docname = this.moduleSpacesService.getDocName(eventData.msgData.docId);
        this.sendName(eventData.fromGuid, docname);
        break;
      case MESSAGE.MSGTYPE.SHOW_SHARE_DIALOG:
        const datashare = eventData.msgData;
        this.shareDocService.showShareDocDialog(datashare.docId, datashare.docType, datashare.name, datashare.googleId || '', datashare.showClassroom, datashare.isShared, datashare.showOnlyQrCode);
        break;
      case MESSAGE.MSGTYPE.OPEN_FROM_DRIVE:
        this.shellStateService.createPickerbyMimetypesForModule(eventData.fromGuid, eventData.msgData.mimeTypes);
        break;
      case MESSAGE.MSGTYPE.SET_LOADING_STATUS:
        if (eventData.msgData.isLoading as boolean)
          this.loaderService.startLoading(eventData.msgData.loadingId, eventData.msgData.message, eventData.msgData.progress);
        else
          this.loaderService.stopLoading(eventData.msgData.loadingId);
        break;
      case MESSAGE.MSGTYPE.GET_INITIAL_STATE:

        const options: UserConfigOptionsDto = {
          claireEnabledInConfig: this.claireConfigService.isClaireEnabledByConfig() && this.claireConfigService.isClaireEnabledByConfig(),
        }

        const state: InitialStateDto = {
          language: this.ttsService.selectedLanguage(),
          theme: this.themeManagerService.currentAppliedTheme(),
          guiLanguage: this.cookieService.get("GUILanguage"),
          enableTTS: this.shellStateService.isTTSEnabled(),
          languages: UiConstants.languages,
          voices: this.getClonedVoices(),
          shellHost: window.location.origin,
          options: options
        };
        const msg = new SetInitialStateMessage(eventData.fromGuid, state);
        this.sendMessageToGuid(msg, eventData.fromGuid);
        break;
      case MESSAGE.MSGTYPE.COPY_DOC:
        const json = { id: eventData.msgData.docId, name: eventData.msgData.docName, previewPublicUrl: eventData.msgData.previewPublicUrl };
        const docDto = new DocDto(0, json, '', '', '', '');
        this.shellEmittersService.onCopyDoc.emit(docDto);
        break;
      case MESSAGE.MSGTYPE.OPEN_MAP_SHOW:
        this.openMapShow(eventData.msgData.docId);
        break;
      case MESSAGE.MSGTYPE.SWITCH_TO_EDIT_SHOW:
        const doc1 = this.moduleSpacesService.getOpenDocs().find((doc) => doc?.id === eventData.msgData.docId);
        if (doc1) doc1.isInShowMode = eventData.msgData.editShow;

        break;
      case MESSAGE.MSGTYPE.SAVE_DOC_RESPONSE:
        if (eventData.msgData.canClose) {
          this.workspaceService.canCloseDoc.emit(eventData.msgData.docId);
        }
        break;
      case MESSAGE.MSGTYPE.MATH_CONTENT:
        this.shellEmittersService.onMathContentReceived.emit(eventData);
        break;
      case MESSAGE.MSGTYPE.CREATE_MAP_DOC_FILE:
        this.createDocFile(
          eventData.fromGuid,
          eventData.msgData.docId,
          eventData.msgData.html,
          eventData.msgData.filename,
          eventData.msgData.docFileId,
          eventData.msgData.message,
          eventData.msgData.action
        );
        break;
      case MESSAGE.MSGTYPE.OPEN_DOC:
        // const doc = new Map<string, number>();
        // console.log('@@@@@@INIZIO OPEN DOC ' +eventData.msgData.docId);

        // doc.set(eventData.msgData.docId, new Date().getTime());
        // this.docOpenedTime.push(doc);
        this.openDocument(eventData.msgData.docId);
        break;

      case MESSAGE.MSGTYPE.DOC_OPENED:
        this.shellEmittersService.onOpenedDoc.emit(eventData.msgData.docId);
        break;

      case MESSAGE.MSGTYPE.FIND_IN_DOC:
        this.shellEmittersService.onFindInDoc.emit(eventData.msgData.activeFind);
        break;

      case MESSAGE.MSGTYPE.SELECTION_CHANGE:
        console.log(eventData.fromGuid + ' ' + JSON.stringify(eventData.msgData));
        const selection = Object.assign(new SelectionDataDto(), eventData.msgData);
        this.shellEmittersService.onSelectionChange.emit({ guid: eventData.fromGuid, selection: selection });
        break;
      case MESSAGE.MSGTYPE.SPEAK:
        if (eventData.msgData.text.trim() !== '' && (this.shellStateService.isTTSEnabled() || eventData.msgData.forceSpeaking)) {
          this.shellStateService.readingGuid = eventData.fromGuid;
          this.ttsService.speak(
            eventData.msgData.caller || CALLER.shell,
            eventData.msgData.text || '',
            eventData.msgData.language || 'it-IT',
            eventData.msgData.forceSpeaking || false,
            eventData.msgData.speechRate || 1
          );
        }
        break;
      case MESSAGE.MSGTYPE.STOP_SPEAK:
        this.shellStateService.readingGuid = '';
        this.ttsService.stop(true);
        break;
      case MESSAGE.MSGTYPE.PLAY_RESPONSE:
        // this.shellStateService.readingGuid = eventData.fromGuid;
        this.ttsService.speak(
          eventData.msgData.caller || CALLER.shell,
          eventData.msgData.text || '',
          eventData.msgData.language || this.ttsService.selectedLanguage()
        );
        break;
      case MESSAGE.MSGTYPE.LANGUAGE_CHANGED:
        const guid = eventData.fromGuid;
        const language = eventData.msgData.language;
        const isSupportedByModule = eventData.msgData.isSupportedByModule;
        this.shellEmittersService.onDocLanguageChangedFromModule.emit({ guid: guid, language: language, isSupportedByModule: isSupportedByModule });
        break;
      case MESSAGE.MSGTYPE.COPY_RESPONSE:
        this.shellEmittersService.onCopyReceived.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.SPEECH_RECOGNITION_TO_SHELL:
        this.shellEmittersService.onSpeechEditUpdate.emit({ isEnabled: eventData.msgData.isEnabled, text: '' });
        break;
      case MESSAGE.MSGTYPE.MODULE_CROP_RECEIVED:
        const data: any = eventData;
        this.workspaceService.screenLockedCapturing.update(() => false);
        this.shellEmittersService.onModuleCropReceived.emit(data);
        break;
      case MESSAGE.MSGTYPE.LOCK_DOC: {
        const data = { docId: eventData.msgData.docId };
        this.shellEmittersService.onLockDoc.emit(data);
        break;
      }
      case MESSAGE.MSGTYPE.MODULE_READY: {
        // const data = { docId: eventData.msgData.docId }
        try {
          const docId = eventData.msgData.docId;
          const time = this.docOpenedTime.find((doc) => doc.has(docId))?.get(docId);
          if (time) {
            const duration = new Date().getTime() - time;
            this.tracker.trackEvent("Workspace", "Time Open document " + docId, duration + ' ');
            //this.docOpenedTime.slice(this.docOpenedTime.indexOf(doc), 1);
            this.docOpenedTime = this.docOpenedTime.filter(obj => {
              // Object.keys(obj) restituisce un array delle chiavi dell'oggetto.
              // Controlliamo se la chiave da rimuovere è inclusa nelle chiavi dell'oggetto.
              // Vogliamo mantenere (restituire true) solo se NON contiene la chiave.
              return !Object.keys(obj).includes(docId);
            });

          }
        } catch (error) {
          console.log("onModuleReadySubscription error: ", error);
          //   this.functionsError(error);
        }
        this.shellEmittersService.onModuleReady.emit(eventData.msgData.docId);
        break;
      }
      case MESSAGE.MSGTYPE.EDIT_IMAGE: {
        // alert('EDIT IMAGE');
        const data = { base64: eventData.msgData.base64 };
        this.shellEmittersService.onEditImage.emit(data);
        break;
      }
      case MESSAGE.MSGTYPE.CROP_PASTE_IMAGE_DIALOG: {
        const data = { base64: eventData.msgData.base64 };
        this.shellEmittersService.onCropPasteImage.emit(data);
        break;
      }
      case MESSAGE.MSGTYPE.MODULE_STARTED: {
        this.shellEmittersService.onModuleStarted.emit(eventData.msgData.guid);
        break;
      }
      case MESSAGE.MSGTYPE.NETWORK_ERROR: {
        this.networkStatusLineService.offline.update(() => true);
        this.networkStatusLineService.changeStatusLine.emit(false);
        break;
      }
      case MESSAGE.MSGTYPE.DOC_PICKER_REQUEST: {
        this.shellStateService.attachNewDocDocId = eventData.msgData.docId;
        this.shellStateService.attachNewDocNodeId = eventData.msgData.nodeId;
        this.shellStateService.attachNewDocNodeText = this.removeFormattingCharacters(eventData.msgData.nodeText);
        this.docPickerService.showDocPicker(eventData.fromGuid, eventData.msgData.docType);
        break;
      }
      case MESSAGE.MSGTYPE.IMAGE_MAP_RESPONSE: {
        this.shellEmittersService.onImageMapResponse.emit(eventData.msgData.image);
        break;
      }
      case MESSAGE.MSGTYPE.REQUEST_LOGIN: {
        console.log('FROM ADMIN ONLY!!!');
        const currentUrl = this.router.url;
        sessionStorage.setItem("redirectPage", currentUrl);
        this.router.navigate(['login', currentUrl]);
        break;
      }
      case MESSAGE.MSGTYPE.REQUEST_CREDENTIALS_SIMPLE:
        this.userInitialized = this.sendCredentials(eventData.fromGuid, true);
        this.credentialmissing = false;
        break;
      case MESSAGE.MSGTYPE.MAP_FRAGMENT_COPIED:
        this.sendBroadcastMessage(new MapFragmentCopiedMessage(eventData.fromGuid, eventData.msgData));
        break;
      case MESSAGE.MSGTYPE.IMPORT_DOC_FROM_LOCAL:
        this.shellEmittersService.onImportDoc.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.SET_TAB_TITLE:
        this.shellEmittersService.onSetTabTitle.emit(eventData.msgData.title);
        break;
      case MESSAGE.MSGTYPE.FORCE_CLOSE:
        this.workspaceService.canCloseDoc.emit(eventData.msgData.docId);
        break;
      case MESSAGE.MSGTYPE.OPEN_SNACKBAR_FROM_MODULE:
        this.snackbarService.openSnackBar(eventData.msgData.message, eventData.msgData.action, 'alert', 'center', () => { }, () => { });
        break;
      case MESSAGE.MSGTYPE.BUY_CREDITS:
        const credits = eventData.msgData.credits || 0;
        const subscriptionId = eventData.msgData.subscriptionId || '';
        this.buyCreditsService.buyCredits(credits, subscriptionId);
        break;
      case MESSAGE.MSGTYPE.TL_CONFIG:
        this.shellEmittersService.onTLRequestedConfig.emit();
        break;
      case MESSAGE.MSGTYPE.TL_CREDITS:
        this.shellEmittersService.onTLCredits.emit();
        break;
      case MESSAGE.MSGTYPE.TL_USE_CREDITS:
        this.shellEmittersService.onTLUseCredits.emit(eventData.msgData);
        break;
      case MESSAGE.MSGTYPE.TL_TTS:
        if (eventData.msgData) {
          if (eventData.msgData.text) {
            this.ttsService.speak(CALLER.claire, eventData.msgData.text, this.ttsService.selectedLanguage(), true);
          } else {
            this.ttsService.stop(true);
          }
        }
        break;
      case MESSAGE.MSGTYPE.TL_WORKING:
        if (eventData.msgData) {
          const isWorking = eventData.msgData.isWorking || false;
          this.shellEmittersService.onTLWorking.emit(isWorking);
          this.shellStateService.isClaireWorking = isWorking;
          console.log('######## isClaireWorking: ', this.shellStateService.isClaireWorking);
        }
        break;
      case MESSAGE.MSGTYPE.TL_INTERACTION:
        if (eventData.msgData) {
          this.shellEmittersService.onTLInteraction.emit(eventData.msgData);
        }
        break;
      case MESSAGE.MSGTYPE.TL_FROM_MODULE:
        if (eventData.msgData) {
          if (this.authenticationService.isClaireEnabled() && this.claireConfigService.isClaireEnabledByConfig()) {
            this.workspaceService.setOpenExtraType(EXTRA_TYPE.claire);
            this.shellEmittersService.onTLFromModule.emit(eventData);
          }
        }
        break;
      case MESSAGE.MSGTYPE.TOAST_MESSAGE:
        this.snackbarService.openSnackBar(eventData.msgData.message, eventData.msgData.action, '', 'right', () => { }, () => { });
        break;
    }
  }

  openDocument(docId: any) {
    if (window.location.href.includes('/map-show/')) {
      const uri = window.location.origin + '/doc-shared/' + docId;
      window.open(uri, '_blank');
    } else if (window.location.href.includes('/guestspace')) {
      this.shellEmittersService.onOpenLinkedFile.emit(docId);
    } else {
      this.workspaceService.openDocument.emit(docId);
    }
  }

  createDocFile(fromGuid: string, docId: string, html: any, filename: any, docFileId: string, message: string, action: string) {
    this.workspaceService.createDocFile(docId, html, filename, docFileId, message, action).then((docFileId: string) => {
      const iframe = this.findIFrameByGuid(fromGuid);
      if (iframe) {
        const msg = new MapDocCreatedMessage(MODULE_TYPE.SHELL, docFileId);
        iframe.contentWindow?.postMessage(msg, "*");
      }
    })
  }

  public sendEnableTTSBroadcast(value: boolean) {
    this.sendBroadcastMessage(new TtsEnableMessage(MODULE_TYPE.SHELL, value));
  }

  public openMapShow(mapId: string) {
    const _window: any = window;
    const width = _window.screen.availWidth * 0.9;
    const left = _window.screen.availLeft + (_window.screen.availWidth - width) / 2;
    const top = 0;
    const height = _window.screen.availHeight * 0.88;
    const showWindow = _window.open(window.origin + '/map-show/' + mapId, 'smxsshow', 'toolbar=yes,top=' + top + ',left=' + left + ',width=' + width + ',height=' + height, false);
    try {
      showWindow.focus();
    } catch (err) {
      console.log('focus error: ' + err);
    }
  }


  private findIFrameByGuid(guid: string) {
    const iframes = document.getElementsByTagName("iframe");
    for (let i = 0; i < iframes.length; i++) {
      if (iframes[i].id === guid) {
        return iframes[i];
      }
    }
    return null;
  }

  sendMapDocCreatedMessage(fromGuid: any, docFileId: string): boolean {
    let result = false;
    const msg = new MapDocCreatedMessage(MODULE_TYPE.SHELL, docFileId);
    result = true;
    const iframe = this.findIFrameByGuid(fromGuid);
    if (iframe) {
      iframe?.contentWindow?.postMessage(msg, "*");
    } else {
      console.log("[sendMapDocCreatedMessage] iframe not found: " + fromGuid);
    }
    return result;
  }

  sendName(fromGuid: any, docName: string): boolean {
    let result = false;
    const msg = new NameResponseMessage(MODULE_TYPE.SHELL, docName);
    result = true;
    const iframe = this.findIFrameByGuid(fromGuid);
    if (iframe) {
      iframe?.contentWindow?.postMessage(msg, "*");
    } else {
      console.log("[sendName] iframe not found: " + fromGuid);
    }
    return result;
  }



  sendCredentials(fromGuid: any, simple: boolean = false): boolean {
    let result = false;
    if (this.authenticationService.isAuthenticated()) {
      this.authenticationService.reloadCredentials();
      const msgData = {
        credentials: JSON.stringify(this.authenticationService.credentials),
        fbcredentials: localStorage.getItem("fbcredentials"),
        token: localStorage.getItem("token"),
      };
      let msg;
      if (simple) {
        msg = new CredentialResponseSimpleMessage(MODULE_TYPE.SHELL, msgData);
      } else {
        msg = new CredentialsResponseMessage(MODULE_TYPE.SHELL, msgData);
      }
      result = true;
      const iframe = this.findIFrameByGuid(fromGuid);
      if (iframe) {
        iframe?.contentWindow?.postMessage(msg, "*");
      } else {
        console.log("[sendCredentials] iframe not found: " + fromGuid);
      }
    } else if (simple) {
      this.sendBroadcastLogoutMessage();
    } else {
      const msg = new CredentialResponseSimpleMessage(MODULE_TYPE.SHELL, null);
      this.sendBroadcastMessage(msg);
    }
    return result;
  }

  sendBroadcastMessage(message: ShellMessage) {
    const iframes = document.getElementsByTagName("iframe");
    for (let i = 0; i < iframes.length; i++) {
      iframes[i].contentWindow?.postMessage(message, "*");
    }
  }

  sendMessageToFocusedModule(message: ShellMessage): string {

    const doc = this.moduleSpacesService.getOpenDocs()[this.workspaceService.focusedSpace];
    const focusedGuid = doc?.type + "_" + doc?.guid;
    if (!focusedGuid) { console.log("no focused module found"); return ''; };

    const iframe = this.findIFrameByGuid(focusedGuid);
    if (iframe) {
      iframe?.contentWindow?.postMessage(message, "*");
    } else {
      console.log("[sendMessageToFocusedModule] iframe not found: " + focusedGuid);
    }

    if (message.msgType === 'play') {
      switch (doc?.type) {
        case 'map':
          //MATOMO Maps Play
          try {
            console.log('MATOMO event Map Play');
            this.tracker.trackEvent('Map', 'Play', 'Play');
          } catch (e: any) {
            console.error('matomo error ' + e.message);
          }
          break;
        case 'pdf':
          //MATOMO Pdf Play
          try {
            console.log('MATOMO event Pdf Play');
            this.tracker.trackEvent('Pdf', 'Play', 'Play');
          } catch (e: any) {
            console.error('matomo error ' + e.message);
          }
          break;
        case 'editor':
          //MATOMO Editor Play
          try {
            console.log('MATOMO event Editor Play');
            this.tracker.trackEvent('Editor', 'Play', 'Play');
          } catch (e: any) {
            console.error('matomo error ' + e.message);
          }
          break;
      }
    }

    return focusedGuid;
  }

  sendMessageToNonFocusedModule(message: ShellMessage): string {
    const openDocs = this.moduleSpacesService.getOpenDocs();
    const focusedSpace = this.workspaceService.focusedSpace;

    if (openDocs.length === 2) {
      const nonFocusedIndex = focusedSpace === 0 ? 1 : 0;
      const targetDoc = openDocs[nonFocusedIndex];

      if (targetDoc) {
        const targetGuid = targetDoc.type + "_" + targetDoc.guid;
        const iframe = this.findIFrameByGuid(targetGuid);

        if (iframe) {
          iframe?.contentWindow?.postMessage(message, "*");
          return targetGuid;
        } else {
          console.log("[sendMessageToNonFocusedModule] iframe not found: " + targetGuid);
          return '';
        }
      }
    }

    const focusedDoc = openDocs[focusedSpace];
    if (focusedDoc) {
      const focusedGuid = focusedDoc.type + "_" + focusedDoc.guid;
      const iframe = this.findIFrameByGuid(focusedGuid);

      if (iframe) {
        iframe?.contentWindow?.postMessage(message, "*");
        return focusedGuid;
      } else {
        console.log("[sendMessageToNonFocusedModule] iframe not found: " + focusedGuid);
        return '';
      }
    }

    console.log("[sendMessageToNonFocusedModule] no valid target found");
    return '';
  }

  sendBroadcastLogoutMessage() {
    const msg = new UserLogoutMessage(MODULE_TYPE.SHELL, {});
    this.sendBroadcastMessage(msg);
  }

  sendMessageToModulebyGuid(message: ShellMessage, docType: string, guidTo: string) {
    const focusedGuid = docType + "_" + guidTo;
    if (focusedGuid === '_') { console.log("no focused module found"); return; };

    const iframe = this.findIFrameByGuid(focusedGuid);
    if (iframe) {
      iframe?.contentWindow?.postMessage(message, "*");
    } else {

      console.log("[sendMessageToModulebyGuid] iframe not found: " + focusedGuid);
    }
  }


  sendMessageToGuid(message: ShellMessage, guidTo: string) {
    const iframe = this.findIFrameByGuid(guidTo);
    if (iframe) {
      iframe?.contentWindow?.postMessage(message, "*");
    } else {
      console.log("[sendMessageToGuid] iframe not found: " + guidTo);
    }
  }

  private getClonedVoices() {
    const clones = [];
    const voices = this.ttsService.voices();
    for (let i = 0; i < voices.length; i++) {
      const voice = voices[i];
      const clone = {
        default: voice.default,
        lang: voice.lang,
        localService: voice.localService,
        name: voice.name,
        voiceURI: voice.voiceURI,
      };
      clones.push(clone);
    }
    return clones;
  }

  private removeFormattingCharacters(input: string): string {
    return input
      .replace(/[\t\n\v\f\r\u0020\u0085\u00A0\u1680\u180E\u2000-\u200D\u2028\u2029\u202F\u205F\u3000\uFEFF]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

}

